import { Container } from '@cluey/cluey-components';
import React, { useEffect } from 'react';

import { scrollToTop } from '../../util/helpers';
import withHeadTag from '../HeadComponent';
import HubFooter from './HubFooter/HubFooter';
import HubHeader from './HubHeader';

interface HubPageLayoutProps {
  title?: string;
  children: React.ReactNode;
  noContainer?: boolean;
  showFooterBorder?: boolean;
}

const HubPageLayout = ({ title = 'HUB', children, noContainer, showFooterBorder = false }: HubPageLayoutProps) => {
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    // class hub removed from below container
    <div className="flex min-h-screen flex-col">
      <HubHeader title={title} />
      {!noContainer ? (
        <Container className="mb-20 flex flex-grow lg:mb-0">
          <div className="relative w-full pt-5 lg:pt-11">{children}</div>
        </Container>
      ) : (
        children
      )}
      <HubFooter hasCTAAboveFooter={showFooterBorder} />
    </div>
  );
};

export default withHeadTag(HubPageLayout);
